import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Nashville Live Band Karaoke</h3>
            <p>Nashville's Premier Karaoke Entertainment</p>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>info@nashvillelivebandkaraoke.com</p>
            <p>(615) 554-6020</p>
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.instagram.com/nashvillelivebandkaraoke/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                Instagram
              </a>
              <a href="https://www.youtube.com/channel/UCz_99924laysy_Jqhc9X4hg" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                YouTube
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Nashville Live Band Karaoke. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;